import type { AvailableRoles } from '@hooks/useAvailableRoles'

import type { SelectableRole } from '../Team.types'

export const getSelectableRoles = (availableRoles: AvailableRoles): SelectableRole[] =>
  availableRoles.map(({ id, name, description, permissions }) => ({
    checkedValue: id,
    label: name,
    suggestion: description || `A role with ${permissions.length} permissions.`,
  }))
